import { render, staticRenderFns } from "./UserPageDesign.vue?vue&type=template&id=7621925b&scoped=true&"
import script from "./UserPageDesign.vue?vue&type=script&lang=js&"
export * from "./UserPageDesign.vue?vue&type=script&lang=js&"
import style0 from "./UserPageDesign.vue?vue&type=style&index=0&id=7621925b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7621925b",
  null
  
)

export default component.exports